import { gql } from "@apollo/client";

const UPDATE_USER = gql`
  mutation updateUser(
    $id: Float!
    $name: String
    $surname: String
    $middle_name: String
    $name_passport: String
    $middle_name_passport: String
    $surname_passport: String
    $email: String
    $phone: String
    $nation: String
    $gender: String
    $city: String
    $street: String
    $user_club_text: String
    $role: String
    $dob: String
    $avatar: Upload
    $avatarLink: String
    $citizenship: String
    $user_address: String
    $facebook: String
    $instagram: String
    $tiktok: String
    $youtube: String
    $linkedIn: String
    $website: String
    $ipinId: String
    $duprId: String
    $teId: String
    $ltsU10Id: String
    $atpId: String
    $wtaId: String
    $fideId: String
    $teU12Id: String
    $bonusU14: String
    $bonusU12: String
    $bonusPoints: String
    $bonusU16: String
    $otherPoints: String
    $user_club_id: Float
    $visitedNewOnboarding: Boolean
    $wprPlayerId: String
    $platforms: [Int!]
    $fivb: String
    $itf_points: String
    $user_national_id_2: String
    $additionalUserRole: String
    $club_access: Boolean
    $coach_access: Boolean
    $parent_access: Boolean
    $uciId: String
    $fipPoints: String
  ) {
    updateUser(
      updateUserInput: {
        id: $id
        name: $name
        surname: $surname
        middle_name: $middle_name
        name_passport: $name_passport
        middle_name_passport: $middle_name_passport
        surname_passport: $surname_passport
        email: $email
        phone: $phone
        nation: $nation
        gender: $gender
        city: $city
        street: $street
        user_club_text: $user_club_text
        role: $role
        dob: $dob
        avatar: $avatar
        avatarLink: $avatarLink
        citizenship: $citizenship
        user_address: $user_address
        instagram: $instagram
        facebook: $facebook
        tiktok: $tiktok
        youtube: $youtube
        linkedIn: $linkedIn
        website: $website
        ipinId: $ipinId
        duprId: $duprId
        teId: $teId
        ltsU10Id: $ltsU10Id
        atpId: $atpId
        wtaId: $wtaId
        fideId: $fideId
        teU12Id: $teU12Id
        bonusU14: $bonusU14
        bonusU12: $bonusU12
        bonusPoints: $bonusPoints
        bonusU16: $bonusU16
        otherPoints: $otherPoints
        user_club_id: $user_club_id
        visitedNewOnboarding: $visitedNewOnboarding
        wprPlayerId: $wprPlayerId
        platforms: $platforms
        fivb: $fivb
        itf_points: $itf_points
        user_national_id_2: $user_national_id_2
        additionalUserRole: $additionalUserRole
        club_access: $club_access
        coach_access: $coach_access
        parent_access: $parent_access
        uciId: $uciId
        fipPoints: $fipPoints
      }
      isDashboardOrManager: true
    ) {
      email
      name
      surname
      dob
      email
      nation
      phone
      role
      avatar
      user_club_text
      street
      city
      gender
      id
      citizenship
      user_address
      instagram
      facebook
      tiktok
      youtube
      linkedIn
      website
      ipinId
      visitedNewOnboarding
      #fideId
      #teId
      #ltsU10Id
      #atpId
      #wtaId
    }
  }
`;

export default UPDATE_USER;
